// Shared translation files
import deDECommon from '@ucc/cc-common-ui/i18n/de-DE.json';
import enAUCommon from '@ucc/cc-common-ui/i18n/en-AU.json';
import enCACommon from '@ucc/cc-common-ui/i18n/en-CA.json';
import enGBCommon from '@ucc/cc-common-ui/i18n/en-GB.json';
import enIECommon from '@ucc/cc-common-ui/i18n/en-IE.json';
import enUSCommon from '@ucc/cc-common-ui/i18n/en-US.json';
import esESCommon from '@ucc/cc-common-ui/i18n/es-ES.json';
import esMXCommon from '@ucc/cc-common-ui/i18n/es-MX.json';
import frCACommon from '@ucc/cc-common-ui/i18n/fr-CA.json';
import frFRCommon from '@ucc/cc-common-ui/i18n/fr-FR.json';
import itITCommon from '@ucc/cc-common-ui/i18n/it-IT.json';
import jaJPCommon from '@ucc/cc-common-ui/i18n/ja-JP.json';
import koKRCommon from '@ucc/cc-common-ui/i18n/ko-KR.json';
import ptBRCommon from '@ucc/cc-common-ui/i18n/pt-BR.json';
import { Locale } from '@ucc/cc-common-ui/i18n/types';
import zhCNCommon from '@ucc/cc-common-ui/i18n/zh-CN.json';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Translation files
import deDE from './de-DE.json';
import enAU from './en-AU.json';
import enCA from './en-CA.json';
import enGB from './en-GB.json';
import enIE from './en-IE.json';
import enUS from './en-US.json';
import esES from './es-ES.json';
import esMX from './es-MX.json';
import frCA from './fr-CA.json';
import frFR from './fr-FR.json';
import itIT from './it-IT.json';
import jaJP from './ja-JP.json';
import koKR from './ko-KR.json';
import ptBR from './pt-BR.json';
import zhCN from './zh-CN.json';

// We declare our translations
const resources = {
  'de-DE': {
    translation: {
      ...deDECommon,
      ...deDE
    }, // German (Germany)
  },
  'en-AU': {
    translation: {
      ...enAUCommon,
      ...enAU
    }, // English (Australia)
  },
  'en-CA': {
    translation: {
      ...enCACommon,
      ...enCA
    }, // English (Canada)
  },
  'en-GB': {
    translation: {
      ...enGBCommon,
      ...enGB
    }, // English (United Kingdom)
  },
  'en-IE': {
    translation: {
      ...enIECommon,
      ...enIE
    }, // English (Ireland)
  },
  'en-US': {
    translation: {
      ...enUSCommon,
      ...enUS
    }, // English (United States)
  },
  'es-ES': {
    translation: {
      ...esESCommon,
      ...esES
    }, // Spanish (Spain)
  },
  'es-MX': {
    translation: {
      ...esMXCommon,
      ...esMX
    }, // Spanish (Mexico)
  },
  'fr-CA': {
    translation: {
      ...frCACommon,
      ...frCA
    }, // French (Canada)
  },
  'fr-FR': {
    translation: {
      ...frFRCommon,
      ...frFR
    }, // French (France)
  },
  'it-IT': {
    translation: {
      ...itITCommon,
      ...itIT
    }, // Italian (Italy)
  },
  'ja-JP': {
    translation: {
      ...jaJPCommon,
      ...jaJP
    }, // Japanese (Japan)
  },
  'ko-KR': {
    translation: {
      ...koKRCommon,
      ...koKR
    }, // Korean (Korea)
  },
  'pt-BR': {
    translation: {
      ...ptBRCommon,
      ...ptBR
    }, // Portuguese (Brazil)
  },
  'zh-CN': {
    translation: {
      ...zhCNCommon,
      ...zhCN
    }, // Chinese (Simplified)
  },
};

export const i18nInstance = i18n.createInstance();

// We initialize i18n
const i18nInit = (locale: Locale) =>
  i18nInstance
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
      resources,
      debug: true,
      lng: locale, // default language
      fallbackLng: 'en-US',
      keySeparator: false, // we do not use keys in form messages.welcome
      nsSeparator: false, // we do not use keys in the form messages:welcome
      interpolation: {
        escapeValue: false, // react already safes from xss
      },
      react: {
        transKeepBasicHtmlNodesFor: [],
        useSuspense: false, // To avoid memory leak on render not finished
      },
    });

export default i18nInit;
